import script from "./TeacherQADashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherQADashboard.vue?vue&type=script&setup=true&lang=js"

import "./TeacherQADashboard.vue?vue&type=style&index=0&id=1f75456c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f75456c"]])

export default __exports__